import { StorePreorderVariant } from "@/types/global"

/**
 * Fetches the active preorder config for a single variant from the custom
 * store route we created in Medusa: GET /store/variants/:id/preorder
 *
 * This is called client-side instead of requesting `*variants.preorder_variant`
 * in the product list fields, which would cause a MikroORM error because
 * cross-module linked fields can't be populated via the standard route.
 */
export async function fetchVariantPreorder(
  variantId: string,
  backendUrl: string,
  publishableKey?: string
): Promise<StorePreorderVariant | null> {
  if (!variantId) return null

  try {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    }
    if (publishableKey) {
      headers["x-publishable-api-key"] = publishableKey
    }

    const res = await fetch(
      `${backendUrl}/store/variants/${encodeURIComponent(variantId)}/preorder`,
      { headers, cache: "no-store" }
    )

    if (!res.ok) return null

    const data = await res.json()
    return data.preorder_variant ?? null
  } catch {
    return null
  }
}
